<template>
  <v-card flat>
    <div
      style="margin-top:30px;text-align:center;"
    >
      <div class="title" style="color:#666">シンプルで、共有できる</div>
      <div class="display-2" style="margin-top:24px;">お買い物リスト</div>
      <div class="subtitle-1" style="margin-top:24px;color:#666">Simple, Sharable and Concurrent Editable</div>
    </div>
    <p style="text-align:center;margin-top:30px;">
      <v-layout row wrap>
        <v-flex style="text-align:right;">
          <a href='https://play.google.com/store/apps/details?id=com.katsulabo.simpleToDo&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
            <img style="width:180px;" alt='Google Play で手に入れよう' src='https://play.google.com/intl/ja/badges/static/images/badges/ja_badge_web_generic.png'/>
          </a>
        </v-flex>
        <v-flex style="text-align:left;">
          <router-link class="button-4" :to="{name: 'Home'}">Webで使ってみる</router-link>
        </v-flex>
      </v-layout>
    </p>
    <p style="margin-top: 100px;">
      <img src="/img/app-min.png" style="width:100%">
    </p>
    <p style="text-align:center;margin-top:30px;">
      <v-layout row wrap>
        <v-flex style="text-align:right;">
          <a href='https://play.google.com/store/apps/details?id=com.katsulabo.simpleToDo&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
            <img style="width:180px;" alt='Google Play で手に入れよう' src='https://play.google.com/intl/ja/badges/static/images/badges/ja_badge_web_generic.png'/>
          </a>
        </v-flex>
        <v-flex style="text-align:left;">
          <router-link class="button-4" :to="{name: 'Home'}">Webで使ってみる</router-link>
        </v-flex>
      </v-layout>
    </p>
    <div style="margin-top:50px">
      <h2 style="text-align:center">よくある質問</h2>
      <v-row>
        <v-col cols=12 v-for="(qa, index) in qas" :key=index>
          <v-card flat outlined>
            <v-container>
            <v-row>
              <v-col cols=1 style="text-align:center;font-weight:bold;font-size:150%;padding-bottom:0;" class="pink--text">
                Q
              </v-col>
              <v-col cols=11 style="padding-top:18px;padding-bottom:0;font-weight:bold;">
                {{qa.q}}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols=1 style="text-align:center;font-weight:bold;font-size:150%" class="blue--text">
                A
              </v-col>
              <v-col cols=11 style="padding-top:18px;">
                {{qa.a}}
              </v-col>
            </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <p style="text-align:center;margin-top:30px;">
      <v-layout row wrap>
        <v-flex style="text-align:right;">
          <a href='https://play.google.com/store/apps/details?id=com.katsulabo.simpleToDo&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
            <img style="width:180px;" alt='Google Play で手に入れよう' src='https://play.google.com/intl/ja/badges/static/images/badges/ja_badge_web_generic.png'/>
          </a>
        </v-flex>
        <v-flex style="text-align:left;">
          <router-link class="button-4" :to="{name: 'Home'}">Webで使ってみる</router-link>
        </v-flex>
      </v-layout>
    </p>
    <add-list-btn></add-list-btn>
  </v-card>
</template>
<script>
import AddListBtn from '../components/common/AddListBtn';

// @ is an alias to /src
export default {
  name: 'Home',
  data () {
    return {
      qas: [
        {
          q: '作ったリストは誰でも参照できますか？',
          a: 'いいえ。誰でもは参照できません。お買い物リストのURLを共有した方のみ参照・更新することができます。（URL限定公開です。）'
        },
        {
          q: '共有する相手もアプリのインストールは必要ですか？',
          a: 'いいえ、インストールは必要ありません。共有したURLを開けば、お買い物リストの参照や更新ができます。ですので、相手の機種やアプリを気にせずにシェアしていただいて大丈夫です。'
        },
        {
          q: 'PC（パソコン）でも使えますか？',
          a: 'はい、PCでもご利用いただけます。'
        },
        {
          q: '料金は発生しますか？',
          a: 'いいえ、現時点では、本アプリはユーザー課金は発生しません。全ての機能が無料でご利用いただけます。'
        }
      ]
    }
  },
  components: {
    AddListBtn
  },
  computed: {
    isLogin () {
      return this.$store.state.user.isLogin
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      // 匿名認証
      if (!this.isLogin) {
        await this.$store.dispatch('user/loginAnonymous')
      } 
      // else {
      //   if (!this.$route.query.from) {
      //     this.$router.push({name: 'Home'})
      //   }
      // }
    }
  }
}
</script>
<style scoped>
.button-4 {
  display: inline-block;
  padding: 0.6em 0.5em;
  margin-top:12px;
  font-size: 1.1em;
  color: #fff;
  text-decoration: none;
  user-select: none;
  background: rgb(233,30,99);
  background: linear-gradient(90deg, rgba(233,30,99,1) 0%, rgba(156,39,176,1) 100%);
  border-radius: 3px;
  box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14), 0 1px 2px 0 rgba(0, 0, 0, 0.12);
  transition: 0.2s ease;
}

.button-4:hover {
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2), 0 1px 8px 0 rgba(0, 0, 0, 0.12);
}
</style>